export enum AuditEvent {
    View = 'Audit.View',
    Filter = 'Audit.Filter',
    Export = 'Audit.Export',
}
